import { render, staticRenderFns } from "./orgRemittancesRanked.vue?vue&type=template&id=05f1a44d&scoped=true&"
import script from "./orgRemittancesRanked.vue?vue&type=script&lang=js&"
export * from "./orgRemittancesRanked.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05f1a44d",
  null
  
)

export default component.exports